<template>
  <v-card rounded="sm">
    <v-card-title>
      <h6 class="font-weight-bold">
        Visão gráfica
      </h6>
    </v-card-title>
    <v-card-text>
      <v-btn
        color="nitro"
        class="white--text mb-6"
        small
      >
        <span class="first-letter-capitalize">
          Proporção de acertos
        </span>
      </v-btn>
      <highcharts :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

  computed: {
    ...mapGetters(['cycles']),
    
    filteredCycles() {
      return this.cycles?.filter(cycle => cycle.challenge?.finished_at) || [];
    },
    
    cycleCategories() {
      return this.filteredCycles.map((cycle) => cycle.cycle_name);
    },
    
    performanceData() {
      return this.filteredCycles.map(cycle => ({
        y: Number(cycle.performance ?? 0),
        name: `Ciclo ${cycle.order}`
      }));
    },
    
    chartOptions() {
      return {
        chart: {
          type: 'line',
          backgroundColor: 'transparent',
          style: {
            fontFamily: 'Inter, sans-serif'
          }
        },
        title: {
          text: null,
          style: {
            fontFamily: 'Inter, sans-serif'
          }
        },
        xAxis: {
          type: 'category',
          categories: this.cycleCategories,
          labels: {
            style: {
              fontFamily: 'Inter, sans-serif'
            }
          }
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: 'Proporção de acertos',
            style: {
              fontFamily: 'Inter, sans-serif'
            }
          },
          gridLineWidth: 1,
          gridLineColor: '#e0e0e0',
          labels: {
            format: '{value}%',
            style: {
              fontFamily: 'Inter, sans-serif'
            }
          }
        },
        legend: {
          enabled: true,
          itemStyle: {
            fontFamily: 'Inter, sans-serif'
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px; font-family: Inter, sans-serif">{point.name}</span><br>',
          pointFormat: '<b style="font-family: Inter, sans-serif">{point.y:.0f}%</b>',
          style: {
            fontFamily: 'Inter, sans-serif'
          }
        },
        plotOptions: {
          series: {
            color: '#0601c0',
            lineWidth: 2,
            marker: {
              enabled: true,
              radius: 12,
              symbol: 'square',
              fillColor: '#0601c0',
              lineColor: '#fff',
              lineWidth: 2
            },
            dataLabels: {
              enabled: true,
              format: '{point.y:.0f}%',
              inside: true,
              align: 'center',
              verticalAlign: 'middle',
              style: {
                color: '#ffffff',
                fontSize: '9px',
                fontWeight: 'normal',
                fontFamily: 'Inter, sans-serif'
              }
            }
          }
        },
        plotArea: {
          backgroundColor: 'transparent'
        },
        series: [{
          name: 'Desempenho nos desafios',
          data: this.performanceData
        }]
      };
    }
  }
}
</script>